import React from 'react';
import PropTypes from 'prop-types';
import { ActionMonitorCard } from './ActionMonitorCard';
import { LoadingSpinner } from '../../../common/LoadingSpinner';
import styles from './ActionMonitorSection.module.css';

export const ActionMonitorSection = ({ metrics, loading }) => {
  // Show loading only on initial load (when no data exists)
  if (loading) {
    return (
      <div className={styles.cardGrid}>
        <div className={styles.loadingContainer}>
          <LoadingSpinner />
          <span>Loading monitor data...</span>
        </div>
      </div>
    );
  }

  // If no metrics, show empty state (but don't show errors during disconnections)
  if (!metrics || metrics.length === 0) {
    return (
      <div className={styles.cardGrid}>
        <div className={styles.emptyContainer}>
          <span>No monitor data available</span>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.cardGrid}>
      {metrics.map((metric, idx) => (
        <ActionMonitorCard
          key={`${metric.label}-${idx}`}
          label={metric.label}
          value={metric.value}
          subText={metric.subText}
          status={metric.status}
          statusType={metric.statusType}
          background={metric.background}
        />
      ))}
    </div>
  );
};

ActionMonitorSection.propTypes = {
  metrics: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
      subText: PropTypes.string, 
      status: PropTypes.string,  
      statusType: PropTypes.oneOf(['up', 'down', 'stable']), 
      background: PropTypes.any, // string | object | element
    })
  ),
  loading: PropTypes.bool,
};